export default __webpack_public_path__ + "static/media/pannerAbout.9e80e295.svg";